import { useTranslation } from 'react-i18next';

import { Jumbo, Tabs } from '@treams/treams-ui';
import { Route, Switch } from '@treams/treams-routes';

import useViewerRoles from 'packages/kakapo-ui-application/hooks/useUserRoles';

import ManagerCalendar from './ManagerCalendar';
import { InboxManagerContainerWithoutSidebar } from './inbox/InboxManagerContainer';

export default function Manager() {
	const { t } = useTranslation();
	const { isWorkspaceSuperuser } = useViewerRoles();

	return (
		<>
			<Jumbo
				title={t('manager.startpage.title')}
				description={t('manager.startpage.description')}
				footer={
					<Tabs.Container>
						<Tabs.Item title={t('manager.conversations.forecast.title')} path="/manager" />
						<Tabs.Item
							title={
								isWorkspaceSuperuser ? t('inbox.tab.superuser.title') : t('inbox.tab.manager.title')
							}
							path="/manager/inbox"
						/>
					</Tabs.Container>
				}
			/>
			<Switch>
				<Route path="/manager" exact>
					<ManagerCalendar />
				</Route>
				<Route path="/manager/inbox" exact>
					<InboxManagerContainerWithoutSidebar header={false} />
				</Route>
			</Switch>
		</>
	);
}
